/* eslint-disable @typescript-eslint/no-explicit-any */
import { Fragment } from "react/jsx-runtime";
type SearchInputProp = {
  placeholder?: string;
  manageList: any;
  itemText: string;
  bulkEdit: boolean;
  error?: string | undefined;
};
export const InputBox = ({
  placeholder,
  manageList,
  itemText,
}: SearchInputProp) => {
  const InputPlaceholder = placeholder || "Search";
  return (
    <Fragment>
      <div className="relative min-w-max inline-block mr-3 mb-2    ">
        <input
          value={itemText}
          className="search-text"
          placeholder={InputPlaceholder + "..."}
          type="text"
          onChange={(e) =>
            manageList({
              type: "add-item-text",
              payload: { data: e.target.value },
            })
          }
          onKeyDown={(e) => {
            console.log("e.key", e.key);
            if (e.key === "Enter") {
              e.preventDefault();
              e.stopPropagation();
              manageList({ type: "add", payload: { event: e.key } });
            }
            if (e.key === "Backspace" && itemText === "") {
              e.preventDefault();
              e.stopPropagation();
              manageList({
                type: "remove-last-one",
                payload: { event: e.key },
              });
            }
          }}
        />
      </div>
    </Fragment>
  );
};
